import styled, { css } from 'styled-components';
import { spin } from '../../../../utils/style';
import {
	BaseStyledComponentProps,
	navBarButtonWrapperStyle,
	navBarIconStyle,
	NewStyleColor,
} from '../../../../utils/styles-constants';

interface StyledUpdateFolderTreeButtonProps extends BaseStyledComponentProps {
	isUpdating: boolean;
	isOffline?: boolean;
}

const UpdateFolderTreeButtonContainer = styled('div')`
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
`;

const StyledUpdateFolderTreeButton = styled('button')`
	cursor: pointer;
	${navBarButtonWrapperStyle}
	padding: 4px 1px 2px;
	border-color: transparent;
	background-color: transparent;
	box-sizing: border-box;
	transition: .1s ease-in-out;
	transition-property: opacity, border-color;

	&:focus {
		outline: 0;
	}

	&:disabled {
		cursor: not-allowed;
		opacity: ${(props: StyledUpdateFolderTreeButtonProps) => props.isOffline ? 0.45 : 0.7};
	}

	& > svg {
		${navBarIconStyle}
		fill: ${(props: StyledUpdateFolderTreeButtonProps) =>
			props.isOffline ? NewStyleColor.Grey500 : props.theme.primary.iconsColor};

		${(props: StyledUpdateFolderTreeButtonProps) => props.isUpdating && css`
			animation: ${spin};
		`}
	}

	&:active:not(:disabled) {
		opacity: 0.3;
	}
`;

export {
	UpdateFolderTreeButtonContainer,
	StyledUpdateFolderTreeButton,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MenuManager/Header/UpdateFolderTreeButton/styles.ts